import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { PanelRow } from  '@wordpress/components'
import { dispatch } from '@wordpress/data'
import { sprintf, _n, __} from '@wordpress/i18n';
const __i18n = {
	..._wp_travel_admin.strings
}
export default ( {allData } ) => {
  const [mydate, MyDate ] = useState('');
  const [myend, MyEnd ] = useState('');
  const { updateTripData } = dispatch('WPTravel/TripEdit');

  const { trip_duration } = typeof allData != 'undefined' ? allData : [];
  const { start_date, booking_start, end_date }  = typeof trip_duration != 'undefined' && trip_duration
  var newStartDate = '';
  var newEndDate = '';
  var newBookingDate = ''
  if ( typeof start_date != 'undefined' && start_date != '' ) {
    newStartDate = new Date( start_date );
  }
  if ( typeof end_date != 'undefined' && end_date != '' ) {
    newEndDate = new Date( end_date )
  }

  if ( typeof booking_start != 'undefined' && booking_start != '' ) {
    newBookingDate = new Date( booking_start )
  }

  const startParams =  {
		showMonthDropdown: true,
		// customInput: <DatePickerBtn />, // Just button with custom html.
		showYearDropdown: 'select',
		dropdownMode: "select",
		minDate: new Date(),
		// maxDate: typeof newEndDate != 'undefined' && newEndDate || '',
		// onChange: selectTripDate,
		// filterDate: IsTourDate( props ),
		// locale:"DPLocale",
    // startDate:null,
    // endDate:null
	}
  const endParams =  {
		showMonthDropdown: true,
		// customInput: <DatePickerBtn />, // Just button with custom html.
		showYearDropdown: true,
		dropdownMode: "select",
		minDate: new Date(),
		// maxDate: new Date(),
		// onChange: selectTripDate,
		// filterDate: IsTourDate( props ),
		// locale:"DPLocale",
        // startDate:null,
        // endDate:null
	}
  
  return (
    <>  
        <PanelRow>
            <label>{__i18n.booking_start_date_label}</label>
            <div className='wp-travel-trip-duration-date-validation-date-picker'>
              <DatePicker
                selected={ typeof newBookingDate != 'undefined' && newBookingDate || '' }
                { ...startParams }
                onChange={ ( val ) =>{
                  // const fomatedDate = moment( val ).fo
                  const newBookingStart = { ...trip_duration, booking_start : val }
                  updateTripData({ ...allData, trip_duration : newBookingStart });
                }}
              />
            </div>
        </PanelRow>
        <PanelRow>
            <label>{__i18n.duration_start_date}</label>
            <div className='wp-travel-trip-duration-date-validation-date-picker'>
              <DatePicker
                selected={ typeof newStartDate != 'undefined' && newStartDate || '' }
                { ...startParams }
                onChange={ ( val ) =>{
                  const fomatedDate = moment( val ).fo
                  const newDuration = { ...trip_duration, start_date : val }
                  updateTripData({ ...allData, trip_duration : newDuration });
                }}
              />
            </div>
        </PanelRow>
        <PanelRow>
            <label>{__i18n.duration_end_date}</label>
            <div className='wp-travel-trip-duration-date-validation-date-picker'>
              <DatePicker
                selected={ typeof newEndDate != 'undefined' && newEndDate || ''}
                { ...endParams }
                onChange={ ( val ) =>{
                  const newEndDuration = { ...trip_duration, end_date : val }
                  updateTripData({ ...allData, trip_duration : newEndDuration });
                }}
              />
            </div>
        </PanelRow>
    </>
  )
}

// export default DurationValidation
